import { lazy } from "react";
const CustomAnalysisIndex = lazy(() =>
  import("../view/customAnalysis/CustomAnalysisIndex")
);
const CustomAnalysisDetail = lazy(() =>
  import("../view/customAnalysis/CustomAnalysisDetail")
);
const category = [
  
  // 展厅客户分析明细
  {
    path: "/customAnalysis/index",
    component:CustomAnalysisIndex,
    id:"CustomAnalysisIndex"
  },
  {
    path: "/customAnalysis/detail",
    component:CustomAnalysisDetail,
    id:"customAnalysisDetail"
  }
];
export default category;
